import { createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["ValidationProvider"], {
    "default-values": $setup.defaultValues,
    "default-errors": $props.serverErrors,
    resolver: $setup.resolver,
    "instant-validate": "",
    onSubmit: $setup.onSubmit
  }, {
    default: _withCtx(({ submitted, handleSubmit }) => [
      _createVNode($setup["FormLayout"], {
        ref: "form",
        action: "/demo-request",
        method: "post",
        class: _normalizeClass(_ctx.$style.form),
        onSubmit: handleSubmit
      }, {
        default: _withCtx(() => [
          _createVNode($setup["FieldsLayout"], {
            class: _normalizeClass(_ctx.$style.container),
            gap: "20px"
          }, {
            default: _withCtx(() => [
              _createVNode($setup["ValidationField"], {
                hidden: "",
                name: "_xsrf"
              }),
              _createVNode($setup["ValidationField"], {
                hidden: "",
                name: "referer"
              }),
              _createVNode($setup["RegistrationField"], {
                field: "company",
                submitted: submitted,
                placeholder: $setup.i18n('company')
              }, null, 8, ["submitted", "placeholder"]),
              _createVNode($setup["ValidationField"], {
                name: "type",
                class: _normalizeClass(_ctx.$style.radio)
              }, {
                default: _withCtx(({ name, onChange, modelValue }) => [
                  _createVNode($setup["UiRadioGroup"], {
                    name: name,
                    "model-value": modelValue,
                    direction: "row",
                    options: $setup.typeOptions,
                    "onUpdate:modelValue": ($event: any) => (onChange($event))
                  }, null, 8, ["name", "model-value", "onUpdate:modelValue"])
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode($setup["RegistrationField"], {
                field: "first_name",
                submitted: submitted,
                placeholder: $setup.i18n('first_name')
              }, null, 8, ["submitted", "placeholder"]),
              _createVNode($setup["RegistrationField"], {
                field: "last_name",
                submitted: submitted,
                placeholder: $setup.i18n('last_name')
              }, null, 8, ["submitted", "placeholder"]),
              _createVNode($setup["RegistrationField"], {
                field: "email",
                submitted: submitted,
                placeholder: $setup.i18n('email')
              }, null, 8, ["submitted", "placeholder"]),
              _createVNode($setup["RegistrationField"], {
                field: "phone",
                submitted: submitted,
                placeholder: $setup.i18n('phone')
              }, null, 8, ["submitted", "placeholder"]),
              _createVNode($setup["RegistrationField"], {
                field: "position",
                submitted: submitted,
                placeholder: $setup.i18n('position')
              }, null, 8, ["submitted", "placeholder"]),
              _createVNode($setup["ValidationField"], {
                name: "recruiters_amount",
                class: _normalizeClass(_ctx.$style.selectContainer),
                "hide-errors": !submitted
              }, {
                default: _withCtx(({ id, modelValue, onChange, name, invalid }) => [
                  _createVNode($setup["BaseSelectDropdown"], {
                    id: id,
                    class: _normalizeClass([_ctx.$style.select, { [_ctx.$style.invalid]: invalid && submitted }]),
                    items: $setup.recruitersSelectOptions,
                    "model-value": modelValue,
                    "show-checkbox": "",
                    placeholder: $setup.i18n('recruiters_amount'),
                    name: name,
                    "onUpdate:modelValue": onChange
                  }, null, 8, ["id", "class", "items", "model-value", "placeholder", "name", "onUpdate:modelValue"])
                ]),
                error: _withCtx(({ error }) => [
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.$style.error)
                  }, _toDisplayString(error.message), 3)
                ]),
                _: 2
              }, 1032, ["class", "hide-errors"]),
              _createVNode($setup["ValidationField"], {
                name: "software",
                class: _normalizeClass(_ctx.$style.selectContainer),
                "hide-errors": !submitted
              }, {
                default: _withCtx(({ id, modelValue, invalid, onChange, name }) => [
                  _createVNode($setup["BaseSelectDropdown"], {
                    id: id,
                    class: _normalizeClass([_ctx.$style.select, { [_ctx.$style.invalid]: invalid && submitted }]),
                    items: $setup.softwareSelectOptions,
                    "show-checkbox": "",
                    "model-value": modelValue,
                    placeholder: $setup.i18n('software'),
                    name: name,
                    "onUpdate:modelValue": onChange
                  }, null, 8, ["id", "class", "items", "model-value", "placeholder", "name", "onUpdate:modelValue"])
                ]),
                error: _withCtx(({ error }) => [
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.$style.error)
                  }, _toDisplayString(error.message), 3)
                ]),
                _: 2
              }, 1032, ["class", "hide-errors"]),
              _createVNode($setup["BaseButton"], {
                class: _normalizeClass(_ctx.$style.button),
                type: "submit"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.i18n('submit')), 1)
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode($setup["ValidationErrors"], {
                name: "common",
                all: false
              }, {
                default: _withCtx(({ message }) => [
                  _createTextVNode(_toDisplayString($setup.i18n(message)), 1)
                ]),
                _: 1
              }),
              _createElementVNode("p", {
                class: _normalizeClass(_ctx.$style.privacyPolicy),
                innerHTML: $setup.i18n('consent') + $setup.privacyPolicyLink
              }, null, 10, _hoisted_1)
            ]),
            _: 2
          }, 1032, ["class"])
        ]),
        _: 2
      }, 1032, ["class", "onSubmit"])
    ]),
    _: 1
  }, 8, ["default-errors", "resolver"]))
}